export enum SearchType {
  region = 'region',
  place = 'place',
  room = 'room',
  neighborhood = 'neighborhood',
  prediction = 'prediction'
}

export interface Search {
  type: SearchType
  title: string,
  url: string,
  data: any
}
